/**
 * Versioni correnti dei documenti legali pubblicati.
 *
 * Quando i contenuti vengono aggiornati:
 *  1. Incrementare la versione del file termini.ts / privacy.ts
 *  2. Aggiornare data_ultima_modifica e data_efficacia
 *  3. Aggiornare la costante qui sotto (e' la fonte di verita' al momento dell'iscrizione)
 *  4. Notificare gli utenti esistenti per ri-accettare (best practice GDPR)
 *
 * Le versioni accettate dall'utente al signup vengono salvate in
 * onboarding_audit/{event_id}.terms_accepted con i numeri di versione.
 */

export const TERMINI_VERSIONE_CORRENTE = '0.1.0-draft';
export const PRIVACY_VERSIONE_CORRENTE = '0.1.0-draft';
